type EnvironmentType = 'local' | 'development' | 'production';

/**
 * The current environment type.
 * @constant {EnvironmentType}
 */
const environment = (process.env.NEXT_PUBLIC_APP_ENV ||
  process.env.NEXT_PUBLIC_ENV ||
  process.env.NODE_ENV ||
  'development') as EnvironmentType;

/**
 * Checks if the current environment matches the specified environment type.
 * @function isEnvironment
 * @param {EnvironmentType} name - The environment type to check.
 * @returns {boolean} True if the current environment matches the specified type, false otherwise.
 */
const isEnvironment = (name: EnvironmentType) => environment == name;

/**
 * Checks if the current environment is production.
 * @function isProduction
 * @returns {boolean} True if the current environment is production, false otherwise.
 */
const isProduction = isEnvironment('production');

/**
 * Checks if the current environment is development.
 * @function isDevelopment
 * @returns {boolean} True if the current environment is development, false otherwise.
 */
const isDevelopment = isEnvironment('development');

/**
 * Checks if the current environment is local.
 * @function isLocal
 * @returns {boolean} True if the current environment is local, false otherwise.
 */
const isLocal = isEnvironment('local');

/**
 * Checks if the application is deployed (based on the presence of AWS_DEFAULT_REGION).
 * @function isDeployed
 * @returns {boolean} True if the application is deployed, false otherwise.
 */
const isDeployed = Boolean(process.env.AWS_DEFAULT_REGION);

export { isDeployed, isEnvironment, isProduction, isDevelopment, isLocal };
